import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SanitizerService {
  private readonly sanitizer = inject(DomSanitizer);

  sanitize = (html?: string): string => this.sanitizer.sanitize(SecurityContext.HTML, html!) || '';
}
